import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=510fb18e&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=510fb18e&prod&lang=scss"
import style1 from "./InvoiceList.vue?vue&type=style&index=1&id=510fb18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fb18e",
  null
  
)

export default component.exports